<template>
  <div class="invoices-history">
    <div class="is-flex space-between">
      <div class="menu-docs">
        <p class="control">
          <RouterLink
            class="button"
            :to="{ name: 'StampedList', query }"
          >
            <BIcon
              class="has-text-success"
              icon="bookmark"
              type="is-small"
            />
            <span>CFDI</span>
          </RouterLink>
        </p>
        <p class="control">
          <RouterLink
            class="button"
            :to="{ name: 'SaleNoteList', query }"
          >
            <BIcon
              class="has-text-primary"
              icon="bookmark"
              type="is-small"
            />
            <span>Notas</span>
          </RouterLink>
        </p>
        <p class="control">
          <RouterLink
            class="button"
            :to="{ name: 'CanceledInvoiceList', query }"
          >
            <BIcon
              class="has-text-danger"
              icon="bookmark"
              type="is-small"
            />
            <span>Canceladas</span>
          </RouterLink>
        </p>
      </div>
      <div>
        <p>
          <a
            class="button is-primary"
            :class="{ 'is-loading': isLoading }"
            :disabled="isLoading"
            @click="downloadCfdis"
          >
            <BIcon icon="cloud-download" />
            <span> Descarga CSV</span>
          </a>
        </p>
      </div>
    </div>

    <div class="field has-addons">
      <template v-if="activeType('fiscal')">
        <p class="control">
          <RouterLink
            class="button"
            :class="activeClass('StampedList')"
            :to="{ name: 'StampedList', query: { size: 20, page: 1 } }"
          >
            <BIcon
              class="has-text-success"
              icon="bookmark"
              type="is-small"
            />
            <span>Facturas</span>
          </RouterLink>
        </p>
        <p class="control">
          <RouterLink
            class="button"
            :class="activeClass('PreInvoiceList')"
            :to="{ name: 'PreInvoiceList', query: { size: 20, page: 1 } }"
          >
            <BIcon
              class="has-text-success"
              icon="bookmark"
              type="is-small"
            />
            <span>PreFacturas</span>
          </RouterLink>
        </p>
        <p class="control">
          <RouterLink
            class="button"
            :to="{ name: 'AutoInvoiceList', query: { size: 20, page: 1 } }"
            :class="activeClass('AutoInvoiceList')"
          >
            <BIcon
              class="has-text-success"
              icon="bookmark"
              type="is-small"
            />
            <span>AutoFacturas</span>
          </RouterLink>
        </p>

        <p class="control">
          <RouterLink
            class="button"
            :to="{ name: 'CreditNoteList', query: { size: 20, page: 1 } }"
            :class="activeClass('CreditNoteList')"
          >
            <BIcon
              class="has-text-success"
              icon="bookmark"
              type="is-small"
            />
            <span>Notas De Crédito</span>
          </RouterLink>
        </p>

        <p class="control">
          <RouterLink
            class="button"
            :to="{ name: 'PayrollsList', query: { size: 20, page: 1 } }"
            :class="activeClass('PayrollsList')"
          >
            <BIcon
              class="has-text-success"
              icon="bookmark"
              type="is-small"
            />
            <span>Nómina</span>
          </RouterLink>
        </p>

        <p
          class="control"
        >
          <RouterLink
            class="button"
            :class="activeClass('RepList')"
            :to="{ name: 'RepList', query: { size: 20, page: 1 } }"
          >
            <BIcon
              class="has-text-success"
              icon="bookmark"
              type="is-small"
            />
            <span>Pagos</span>
          </RouterLink>
        </p>

        <p
          class="control"
        >
          <RouterLink
            class="button"
            :class="activeClass('TradeTransfers')"
            :to="{ name: 'TradeTransfers', query: { size: 20, page: 1 } }"
          >
            <BIcon
              class="has-text-success"
              icon="bookmark"
              type="is-small"
            />
            <span>Cartas Porte</span>
          </RouterLink>
        </p>
      </template>

      <template v-else-if="activeType('nofiscal')">
        <p class="control">
          <RouterLink
            class="button"
            :class="activeClass('SaleNoteList')"
            :to="{ name: 'SaleNoteList', query: { size: 20, page: 1 } }"
          >
            <BIcon
              class="has-text-primary"
              icon="bookmark"
              type="is-small"
            />
            <span>Notas de Remisión</span>
          </RouterLink>
        </p>
        <p class="control">
          <RouterLink
            class="button"
            :class="activeClass('SalaryReceiptList')"
            :to="{ name: 'SalaryReceiptList', query: { size: 20, page: 1 } }"
          >
            <BIcon
              class="has-text-primary"
              icon="bookmark"
              type="is-small"
            />
            <span>Recibos de salario</span>
          </RouterLink>
        </p>
      </template>

      <template v-else>
        <p class="control">
          <RouterLink
            class="button"
            :to="{ name: 'CanceledInvoiceList', query: { size: 20, page: 1 } }"
            :class="activeClass('CanceledInvoiceList')"
          >
            <BIcon
              class="has-text-danger"
              icon="bookmark"
              type="is-small"
            />
            <span>Canceladas</span>
          </RouterLink>
        </p>
      </template>
    </div>
    <RouterView />
  </div>
</template>

<script>
export default {
  name: 'History',
  data() {
    return {
      list: [
        { type: 'fiscal', key: 'StampedList', value: 'is-success' },
        { type: 'fiscal', key: 'PreInvoiceList', value: 'is-success' },
        { type: 'fiscal', key: 'AutoInvoiceList', value: 'is-success' },
        { type: 'fiscal', key: 'CreditNoteList', value: 'is-success' },
        { type: 'fiscal', key: 'PayrollsList', value: 'is-success' },
        { type: 'fiscal', key: 'RepList', value: 'is-success' },
        { type: 'fiscal', key: 'TradeTransfers', value: 'is-success' },
        { type: 'nofiscal', key: 'SaleNoteList', value: 'is-primary' },
        { type: 'nofiscal', key: 'SalaryReceiptList', value: 'is-primary' },
        { type: 'canceled', key: 'CanceledInvoiceList', value: 'is-danger' },
      ],
      query: {
        page: 1,
        size: 20,
      },
      isLoading: false,
    };
  },
  computed: {
    view() {
      const { name } = this.$route;

      const view = this.list.find(({ key }) => name === key);

      return view;
    },
    activeType() {
      return type => this.view.type === type;
    },
    activeClass() {
      return (name) => {
        const value = this.view.key === name ? this.view.value : '';

        return value;
      };
    },
  },
  methods: {
    async downloadCfdis() {
      const now = new Date();

      this.$store.commit('ui/addNotification', {
        type: 'info',
        content: 'Descargando...',
        dateTime: now,
      });

      await this.$store.dispatch('invoices/downloadAll');

      this.$store.commit('ui/deleteNotification', now);
    },
  },
};
</script>

<style scoped>
.router-link-active span.icon.is-small {
  color: white !important;
}

.invoices-history {
  padding: 1rem;
}

.menu-docs {
  display: flex;
  flex-direction: row;
  padding-bottom: 1.5rem;
}

.field.has-addons {
  margin-bottom: 1.5rem;
}

.is-flex.space-between {
  justify-content: space-between;
}
</style>

<style>
.invoices-history .field.has-addons a.router-link-active.button .icon {
  color: white!important;
}
</style>
